import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import MenuItem from "@mui/material/MenuItem";
import LogoIcon from "../../assets/Logo.svg";
import { withTheme } from "@emotion/react";
import NavButton from "../Button/NavButton";
import BtnPrimary from "../Button/BtnPrimary";
import { useNavigate } from "react-router-dom";

const pages = ["About us", "Home healthcare", "Join us"];

function Header(props) {
  const navigate = useNavigate();

  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const theme = props.theme;

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleNavMenu = (page) => {
    if (page === "Join us") {
      navigate("/auth/login");
    }
  };

  const Logo = () => {
    return <img src={LogoIcon} alt="Logo" />;
  };

  return (
    <AppBar
      sx={{
        display: "flex",
        background: "#FFFFFF",
        height: "104px",
        boxShadow: "none",
      }}
      position="static"
    >
      <Container
        sx={{
          py: "24px",
          display: { xs: "block", sm: "flex", md: "block" },
          padding: "0px !important",
          justifyContent: "center",
        }}
        maxWidth="xl"
      >
        <Toolbar sx={{ justifyContent: "space-between" }} disableGutters>
          <Box sx={{ display: { xs: "none", md: "flex" }, mr: 1 }}>
            <Logo />
          </Box>
          <Box
            gap={{ xs: "48px", sm: "29px", md: "48px" }}
            alignItems="center"
            display="flex"
            flexDirection="row"
          >
            <Box sx={{ flexGrow: 1, display: { xs: "flex", sm: "none" } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                sx={{ color: "#1E87FF !important" }}
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: "block", md: "none" },
                }}
              >
                {pages.map((page) => (
                  <MenuItem key={page} onClick={handleCloseNavMenu}>
                    <Typography
                      sx={{ ...theme.typography.button }}
                      textAlign="center"
                    >
                      {page}
                    </Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box>
            <Box
              sx={{ display: { xs: "none", sm: "flex", md: "none" }, mr: 1 }}
            >
              <Logo />
            </Box>
            <Box sx={{ flexGrow: 1, display: { xs: "none", sm: "flex" } }}>
              {pages.map((page) => (
                <NavButton
                  key={page}
                  onClick={() => handleNavMenu(page)}
                  padding={theme.button.padding.p16}
                  height="56px"
                  text={page}
                ></NavButton>
              ))}
            </Box>
            <BtnPrimary text="Make an appointment" height="56px" />
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default withTheme(Header);
